import { render, staticRenderFns } from "./CpuHardwareDetailModal.vue?vue&type=template&id=d331409e&scoped=true"
import script from "./CpuHardwareDetailModal.vue?vue&type=script&lang=js"
export * from "./CpuHardwareDetailModal.vue?vue&type=script&lang=js"
import style0 from "./CpuHardwareDetailModal.vue?vue&type=style&index=0&id=d331409e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d331409e",
  null
  
)

export default component.exports